module.exports = __webpack_public_path__ + "img/saum_koenigsblau_farbnr543.539ea7ea.jpg";